var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"left-container"},[_c('ContainerHeader'),_c('ContainerSubHeader'),_c('ContainerContent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }